import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalFooter, Button, Input, Form, ToggleSwitch, PasswordIndicator } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import { resendInviteRequest, clearRedux } from 'Redux/actions';

const ResendInvite = (props) => {
    const { isPMUser } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const { openModal, loading, result, entity, callback } = useSelector(state => state.resendInviteRedux);

    const closeModal = () => {
        dispatch(clearRedux("RESEND_INVITE"));
    }

    const applyChanges = () => {
        let payload = {
            id: entity?.id,
            entityName: entity?.entityName,
            isPMUser
        }
        dispatch(resendInviteRequest(payload))
    }

    useEffect(() => {
        if (result) {
            if (result?.reset) {
                NotificationManager.success(
                    messages['resend_invite_success_message'],
                    messages['resend_invite_title'],
                    3000,
                );
                callback && callback();
                closeModal();
            } else {
                NotificationManager.error(
                    messages['resend_invite_error_message'],
                    messages['resend_invite_title'],
                    3000,
                );
            }
            dispatch(clearRedux("RESEND_INVITE", { result: null }))
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['resend_invite_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div className="automatic-password-container">
                            <label style={{ marginRight: 5 }} className="input-normal-label">{messages['resend_invite_message']} </label>
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['common_resend']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ResendInvite;